"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { buildRepAvatarItems } from "./buildRepAvatarItems";
import { RateMatter } from "@/types/enums";
import { AnimatePresence, motion } from "framer-motion";
import { useContext, useMemo, useState } from "react";
import IdentityGettingStartedCard from "../identity/getting-started/IdentityGettingStartedCard";
import UserPageIdentityHeaderCICRate from "../identity/header/cic-rate/UserPageIdentityHeaderCICRate";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import UserPageRepModifyModal from "./modify-rep/UserPageRepModifyModal";
import GrantRepDialog from "./new-rep/GrantRepDialog";
import type { RepDirection } from "./UserPageRep.helpers";
import { getCanEditRep, getCanEditNic } from "./UserPageRep.helpers";
import MobileTabCards from "./MobileTabCards";
import MobileRepTabContent from "./MobileRepTabContent";
import MobileIdentityTabContent from "./MobileIdentityTabContent";
type MobileTab = "rep" | "identity";
export default function UserPageRepMobile(t0) {
  const $ = _c(70);
  const {
    profile,
    overview,
    categories,
    cicOverview,
    repDirection,
    onRepDirectionChange,
    initialActivityLogParams,
    loading,
    visibleCount,
    onShowMore,
    hasNextPage,
    isFetchingNextPage,
    onOpenOverviewContributors,
    onOpenCategoryContributors
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    address
  } = useSeizeConnectContext();
  const [activeTab, setActiveTab] = useState("rep");
  const [isGrantRepOpen, setIsGrantRepOpen] = useState(false);
  const [isNicRateOpen, setIsNicRateOpen] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== profile) {
    t1 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = profile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const canEditRep = t1;
  let t2;
  if ($[4] !== activeProfileProxy || $[5] !== address || $[6] !== connectedProfile || $[7] !== profile) {
    t2 = getCanEditNic({
      connectedProfile,
      targetProfile: profile,
      activeProfileProxy,
      address
    });
    $[4] = activeProfileProxy;
    $[5] = address;
    $[6] = connectedProfile;
    $[7] = profile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const canEditNic = t2;
  let t3;
  if ($[9] !== activeProfileProxy || $[10] !== address || $[11] !== profile) {
    t3 = !activeProfileProxy && !!profile.handle && (profile.wallets ?? []).some(w => w.wallet.toLowerCase() === address?.toLowerCase());
    $[9] = activeProfileProxy;
    $[10] = address;
    $[11] = profile;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const canEditStatements = t3;
  cicOverview?.contributors.data;
  let t4;
  if ($[13] !== cicOverview?.contributors.data) {
    t4 = buildRepAvatarItems(cicOverview?.contributors.data ?? [], 3, {
      omitHref: true
    });
    $[13] = cicOverview?.contributors.data;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const cicAvatarItems = t4;
  let t5;
  if ($[15] !== profile) {
    t5 = <IdentityGettingStartedCard profile={profile} className="tw-mb-4" />;
    $[15] = profile;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== activeTab || $[18] !== cicAvatarItems || $[19] !== cicOverview || $[20] !== onOpenOverviewContributors || $[21] !== overview || $[22] !== profile || $[23] !== repDirection) {
    t6 = <MobileTabCards activeTab={activeTab} onTabChange={setActiveTab} overview={overview} cicOverview={cicOverview} profile={profile} repDirection={repDirection} cicAvatarItems={cicAvatarItems} onOpenOverviewContributors={onOpenOverviewContributors} />;
    $[17] = activeTab;
    $[18] = cicAvatarItems;
    $[19] = cicOverview;
    $[20] = onOpenOverviewContributors;
    $[21] = overview;
    $[22] = profile;
    $[23] = repDirection;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== activeTab || $[26] !== canEditNic || $[27] !== canEditRep || $[28] !== canEditStatements || $[29] !== categories || $[30] !== cicOverview || $[31] !== hasNextPage || $[32] !== initialActivityLogParams || $[33] !== isFetchingNextPage || $[34] !== loading || $[35] !== onOpenCategoryContributors || $[36] !== onRepDirectionChange || $[37] !== onShowMore || $[38] !== overview || $[39] !== profile || $[40] !== repDirection || $[41] !== visibleCount) {
    t7 = <AnimatePresence mode="wait">{activeTab === "rep" ? <motion.div key="rep" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileRepTabContent profile={profile} overview={overview} categories={categories} repDirection={repDirection} onRepDirectionChange={onRepDirectionChange} initialActivityLogParams={initialActivityLogParams} loading={loading} canEditRep={canEditRep} visibleCount={visibleCount} onShowMore={onShowMore} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} onGrantRep={() => setIsGrantRepOpen(true)} onEditCategory={setEditCategory} onOpenCategoryContributors={onOpenCategoryContributors} /></motion.div> : <motion.div key="identity" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}><MobileIdentityTabContent profile={profile} cicOverview={cicOverview} initialActivityLogParams={initialActivityLogParams} canEditNic={canEditNic} canEditStatements={canEditStatements} onRateNic={() => setIsNicRateOpen(true)} /></motion.div>}</AnimatePresence>;
    $[25] = activeTab;
    $[26] = canEditNic;
    $[27] = canEditRep;
    $[28] = canEditStatements;
    $[29] = categories;
    $[30] = cicOverview;
    $[31] = hasNextPage;
    $[32] = initialActivityLogParams;
    $[33] = isFetchingNextPage;
    $[34] = loading;
    $[35] = onOpenCategoryContributors;
    $[36] = onRepDirectionChange;
    $[37] = onShowMore;
    $[38] = overview;
    $[39] = profile;
    $[40] = repDirection;
    $[41] = visibleCount;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  let t8;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsGrantRepOpen(false);
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] !== isGrantRepOpen || $[45] !== overview || $[46] !== profile) {
    t9 = <GrantRepDialog profile={profile} overview={overview} isOpen={isGrantRepOpen} onClose={t8} />;
    $[44] = isGrantRepOpen;
    $[45] = overview;
    $[46] = profile;
    $[47] = t9;
  } else {
    t9 = $[47];
  }
  let t10;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsNicRateOpen(false);
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  let t12;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsNicRateOpen(false);
    t12 = () => setIsNicRateOpen(false);
    $[49] = t11;
    $[50] = t12;
  } else {
    t11 = $[49];
    t12 = $[50];
  }
  let t13;
  if ($[51] !== profile) {
    t13 = <UserPageIdentityHeaderCICRate profile={profile} isTooltip={false} onSuccess={t11} onCancel={t12} />;
    $[51] = profile;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  let t14;
  if ($[53] !== profile || $[54] !== t13) {
    t14 = <div className="tw-px-4 sm:tw-px-6"><UserPageRateWrapper profile={profile} type={RateMatter.NIC}>{t13}</UserPageRateWrapper></div>;
    $[53] = profile;
    $[54] = t13;
    $[55] = t14;
  } else {
    t14 = $[55];
  }
  let t15;
  if ($[56] !== isNicRateOpen || $[57] !== t14) {
    t15 = <MobileWrapperDialog title="Rate NIC" isOpen={isNicRateOpen} onClose={t10} tabletModal={true} maxWidthClass="md:tw-max-w-md">{t14}</MobileWrapperDialog>;
    $[56] = isNicRateOpen;
    $[57] = t14;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== canEditRep || $[60] !== editCategory || $[61] !== profile) {
    t16 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[59] = canEditRep;
    $[60] = editCategory;
    $[61] = profile;
    $[62] = t16;
  } else {
    t16 = $[62];
  }
  let t17;
  if ($[63] !== t15 || $[64] !== t16 || $[65] !== t5 || $[66] !== t6 || $[67] !== t7 || $[68] !== t9) {
    t17 = <div>{t5}{t6}{t7}{t9}{t15}{t16}</div>;
    $[63] = t15;
    $[64] = t16;
    $[65] = t5;
    $[66] = t6;
    $[67] = t7;
    $[68] = t9;
    $[69] = t17;
  } else {
    t17 = $[69];
  }
  return t17;
}